import type { RouteRecordRaw } from "vue-router";
import { BREADCRUMBS } from "~/core/constants/breadcrumbs";
import { PATH_LOGS } from "~/modules/log/constants";
import LogsPage from "~/modules/log/views/LogsPage.vue";

const routes: RouteRecordRaw[] = [
  {
    path: PATH_LOGS,
    component: LogsPage,
    meta: {
      auth: true,
      breadcrumb: BREADCRUMBS.LOGS,
    },
  },
];

export default routes;
